import type { Company } from 'context/authentication/Company.types'
import { Role } from 'context/authentication/Role.types'

export interface UserData {
  cid: string
  email: string
  displayName: string
  roles: Record<string, Role>
  uid: string
  companies: Company[]
}

export interface StoreLanguageCommand {
  language: string
}

export enum WelcomeGuideStatus {
  PENDING = 'PENDING',
  SKIPPED = 'SKIPPED',
  DONE = 'DONE',
}

export interface UserPreferencesData {
  locale?: string
  timeZoneId?: string
  welcomeGuideTripList?: WelcomeGuideStatus
  welcomeGuideTripDetails?: WelcomeGuideStatus
  wantsNewTripEmail?: boolean
  wantsUpdateTripEmail?: boolean
  wantsTripCancellationEmail?: boolean
  measurementsSystem?: MeasurementsSystem
}

export interface TimeZone {
  id: string
  displayName: string
}

export enum MeasurementsSystem {
  METRIC = 'METRIC',
  IMPERIAL = 'IMPERIAL',
}

export interface NotificationsFormValues {
  wantsNewTripEmail?: boolean
  wantsUpdateTripEmail?: boolean
  wantsTripCancellationEmail?: boolean
}

export interface CreateOrEditUserFormValues {
  email?: string
  displayName?: string
  companyCid?: string
  role?: string
}

export interface BulkCreateUsersDialogFormValues {
  csv: File
}

export interface GrantRoleFormValues {
  companyCid: string
  role: Role
}

export interface RevokeRoleFormValues {
  companyCid: string
  role: Role
}

export interface TemperaturePreferenceFormValues {
  measurementsSystem: MeasurementsSystem
}
